/**
 * Which clients still get the "Client" tab (the config canvas at
 * `/clients/:hostId`).
 *
 * sphinx does not emulate clients — it drives the real ones — so for Claude
 * Desktop, claude.ai, the CLIs and the rest there is nothing on that canvas
 * worth configuring: what they do is decided by the app itself. The two
 * direct-API clients are the exception, because configuration is the entire
 * client: there is no app, only the request sphinx builds.
 */
const DIRECT_API_CLIENT_IDS = new Set(["anthropic-api", "openai-api"]);

export function clientKeepsConfigTab(hostId: string | null): boolean {
  return hostId !== null && DIRECT_API_CLIENT_IDS.has(hostId);
}
